import React from 'react';

export const MetricCell = ({value, percent, color}) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: 6,
      minWidth: 140,
    }}>
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: 13,
      }}>
      <span style={{fontWeight: 500}}>{value.toLocaleString('pt-BR')}</span>

      <span style={{fontSize: 11, color: '#9ca3af'}}>{percent}%</span>
    </div>

    <div
      style={{
        width: '100%',
        height: 6,
        background: '#e5e7eb',
        borderRadius: 999,
        overflow: 'hidden',
      }}>
      <div
        style={{
          width: `${percent}%`,
          height: '100%',
          background: color,
          borderRadius: 999,
        }}
      />
    </div>
  </div>
);
